export default "__VITE_ASSET__9nZRY2aG__";